import type { MDXComponents } from "mdx/types";

export function useMDXComponents(): MDXComponents {
  return {};
}
